export enum AuthProviders {
  // AZURE_AD = 'azure-ad',
  MARTINS_CRED = 'martins-credentials',
  REFRESH_TOKEN = 'refresh-token',
  EXPIRED_MARTINS_CRED = 'expired-martins-credentials',
}
